import React from 'react';
import { CardContainer } from './styles';
import { CardProps } from './types';

const Card: React.FC<CardProps> = ({ children, $grow, $lessPadding }) => {
    return <CardContainer $lessPadding={$lessPadding} $grow={$grow}>{children}</CardContainer>;
};

export default Card;
